export const HEADER_COL_STYLES: Record<string, string> = {
  title: 'max-desktop:flex-1 max-desktop:min-w-[220px] max-[620px]:w-[80%] max-[620px]:flex-none font-heading text-2xl',
  checked: 'max-desktop:w-10 text-sm',
  file: 'max-desktop:w-[200px] max-[620px]:hidden text-sm',
  archive: 'text-right max-desktop:hidden text-sm',
};
